// extracted by mini-css-extract-plugin
export default {"leftNav":"index_leftNav_PKCqq","box":"index_box_TMa1U"};